import React from 'react';
import {
  Popover as BPPopover,
  PopoverProps as IPopoverProps
} from '@blueprintjs/core';
import PortalContainerRef from '../../atoms/portal-container';

const Popover: React.FC<IPopoverProps> = ({ children, ...props }) => {
  return (
    <BPPopover {...props} portalContainer={PortalContainerRef.current}>
      {children}
    </BPPopover>
  );
};

export default Popover;
